import { createContext } from "react";

const ComponentSlideshowContext = createContext(null);

export { ComponentSlideshowContext }; 